(() => {
  function init(root) {
    if (root.dataset.hssReady) return;
    root.dataset.hssReady = 'true';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const money = (cents) => new Intl.NumberFormat('it-IT', {style:'currency',currency:'EUR'}).format(cents / 100);
    const scenesNode = root.querySelector('.hss-scene-data');
    const scenes = scenesNode ? JSON.parse(scenesNode.textContent) : {};
    let sceneTimer;
    root.querySelectorAll('[data-scene]').forEach(button => button.addEventListener('click', () => {
      const scene = scenes[button.dataset.scene];
      if (!scene) return;
      root.querySelectorAll('[data-scene]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      const photo = root.querySelector('.hero-photo');
      const floater = root.querySelector('.product-float');
      clearTimeout(sceneTimer);
      photo.style.opacity = reducedMotion ? '1' : '0';
      const change = () => {
        photo.removeAttribute("srcset");
        photo.src = scene.image;
        photo.alt = scene.alt;
        photo.classList.toggle('tool-scene', button.dataset.scene === 'fai-da-te');
        photo.style.opacity = '1';
        if (floater) {
        floater.href = scene.url;
        floater.querySelector('img').src = scene.thumb;
        floater.querySelector('small').textContent = scene.label;
        floater.querySelector('strong').textContent = scene.title;
        floater.querySelector('b').textContent = scene.price;
        }
        root.querySelector('.scene-label').textContent = button.dataset.scene === 'fai-da-te' ? 'Foto originale del prodotto' : 'Ambientazione illustrativa';
      };
      if (reducedMotion) change(); else sceneTimer = setTimeout(change, 130);
    }));
    root.querySelectorAll('[data-filter]').forEach(button => button.addEventListener('click', () => {
      root.querySelectorAll('[data-filter]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      let count = 0;
      root.querySelectorAll('#hss-products .product-card').forEach(card => {
        card.hidden = button.dataset.filter !== 'all' && card.dataset.category !== button.dataset.filter;
        if (!card.hidden) count++;
      });
      const status = root.querySelector('.filter-status');
      if (status) status.textContent = count ? `${count} prodotti nella selezione` : 'Nessun prodotto disponibile in questa selezione.';
      if (status) status.classList.toggle('sr-only', count > 0);
    }));
    root.querySelectorAll('[data-finish]').forEach(button => button.addEventListener('click', () => {
      root.querySelectorAll('[data-finish]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      root.querySelectorAll('.finish-sample, .finish-preview').forEach(image => {
        image.src = button.dataset.image;
        image.alt = 'Rivestimento 3D ' + button.dataset.name + ', foto del prodotto';
      });
      const stageName = root.querySelector('.finish-stage-name');
      if (stageName) stageName.textContent = button.dataset.name;
      root.querySelector('.finish-name').textContent = button.dataset.name;
      root.querySelector('.finish-link').href = button.dataset.url;
      const price = root.querySelector('.finish-price b');
      if (button.dataset.price && price) price.textContent = button.dataset.price;
    }));
    root.querySelectorAll('[data-card-variant]').forEach(button => button.addEventListener('click', () => {
      if (button.disabled) return;
      const card = button.closest('.product-card');
      card.dataset.selectedVariant = button.dataset.cardVariant;
      card.querySelectorAll('[data-card-variant]').forEach(b => b.setAttribute('aria-pressed', String(b === button)));
      const photo = card.querySelector('.product-photo img');
      if (photo && button.dataset.image) {photo.src = button.dataset.image; photo.removeAttribute('srcset'); photo.alt = card.querySelector('h3').textContent + ' — ' + button.dataset.name;}
      card.querySelector('.card-finish-name').textContent = button.dataset.name;
      if (button.dataset.price) card.querySelector('.price').textContent = button.dataset.price;
      card.querySelectorAll('.variant-link').forEach(link => {link.href = button.dataset.url;});
      const select = card.querySelector('select[name="id"]');
      if (select) select.value = button.dataset.cardVariant;
    }));
    root.querySelectorAll('[data-mars-feature]').forEach(feature => {
      const buttons = Array.from(feature.querySelectorAll('[data-mars-variant]'));
      const select = feature.querySelector('select[name="id"]');
      buttons.forEach(button => button.addEventListener('click', () => {
        buttons.forEach(b => b.setAttribute('aria-pressed', String(b === button)));
        const photo = feature.querySelector('.mars-image');
        photo.src = button.dataset.image;
        photo.removeAttribute('srcset');
        photo.alt = 'Scarpiera MK-MARS4 — ' + button.dataset.name;
        feature.querySelectorAll('[data-mars-name]').forEach(el => {el.textContent = button.dataset.name;});
        feature.querySelector('[data-mars-price]').textContent = button.dataset.price;
        feature.querySelectorAll('[data-mars-link]').forEach(link => {link.href = button.dataset.url;});
        const available = button.dataset.available === 'true';
        const stock = feature.querySelector('[data-mars-stock]');
        stock.textContent = available ? 'Disponibile online' : 'Esaurito';
        stock.dataset.available = String(available);
        if (select) select.value = button.dataset.marsVariant;
        const buy = feature.querySelector('button.mars-buy');
        if (buy) {
          buy.disabled = !available;
          buy.textContent = available ? 'Aggiungi al carrello' : 'Finitura esaurita';
        }
        feature.querySelector('.mars-status').textContent = button.dataset.name + ', ' + button.dataset.price + ', ' + stock.textContent;
      }));
      select?.addEventListener('change', () => buttons.find(b => b.dataset.marsVariant === select.value)?.click());
    });
    const data = root.querySelector('.hss-product-data');
    const products = data ? JSON.parse(data.textContent) : [];
    const dialog = root.querySelector('.quickview');
    if (dialog) {
      let activeProduct, trigger;
      const variant = dialog.querySelector('select');
      const updateVariant = () => {
        const chosen = activeProduct.variants.find(v => String(v.id) === variant.value);
        if (!chosen) return;
        dialog.querySelector('.qv-image').src = chosen.image || activeProduct.image;
        dialog.querySelector('.qv-price').textContent = money(chosen.price);
        dialog.querySelector('.qv-go').href = activeProduct.url + '?variant=' + chosen.id;
      };
      root.querySelectorAll('[data-quick]').forEach(button => button.addEventListener('click', () => {
        activeProduct = products[Number(button.dataset.quick)];
        if (!activeProduct) return;
        trigger = button;
        dialog.querySelector('h2').textContent = activeProduct.title;
        dialog.querySelector('.qv-note').textContent = activeProduct.note;
        dialog.querySelector('.qv-image').alt = activeProduct.fullTitle;
        variant.replaceChildren();
        activeProduct.variants.forEach(v => {
          const option = document.createElement('option');
          option.value = String(v.id);
          option.textContent = (v.title === 'Default Title' ? 'Modello unico' : v.title) + (v.available ? '' : ' — Esaurito');
          option.disabled = !v.available;
          variant.appendChild(option);
        });
        const available = activeProduct.variants.find(v => v.available);
        const selectedId = button.closest('.product-card')?.dataset.selectedVariant;
        const selected = activeProduct.variants.find(v => String(v.id) === selectedId && v.available) || available;
        if (selected) variant.value = String(selected.id);
        updateVariant();
        dialog.showModal();
      }));
      variant.addEventListener('change', updateVariant);
      dialog.querySelector('.qv-close').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) {const r=dialog.getBoundingClientRect(); if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();} });
      dialog.addEventListener('close', () => trigger?.focus());
    }
    root.querySelectorAll('.allcats').forEach(details => {
      details.addEventListener('keydown', e => { if (e.key === 'Escape') { details.open = false; details.querySelector('summary').focus(); } });
    });
    root.querySelectorAll('.native-buy').forEach(form => {
      const select = form.querySelector('select[name="id"]');
      const card = form.closest('.product-card');
      if (card) select?.addEventListener('change', () => {
        const opt = select.selectedOptions[0];
        if (opt.dataset.price) card.querySelector('.price').textContent = opt.dataset.price;
        if (opt.dataset.image) {
          const image = card.querySelector('.product-photo img');
          if (image) {image.src = opt.dataset.image; image.removeAttribute('srcset');}
        }
        card.dataset.selectedVariant = select.value;
        const swatch = Array.from(card.querySelectorAll('[data-card-variant]')).find(b => b.dataset.cardVariant === select.value);
        if (swatch) swatch.click();
        else card.querySelectorAll('.variant-link').forEach(link => { const url = new URL(link.href); url.searchParams.set('variant', select.value); link.href = url.href; });
      });
      form.addEventListener('submit', async event => {
        event.preventDefault();
        const button = form.querySelector('[type="submit"]');
        const status = form.querySelector('[role="status"]');
        button.disabled = true;
        status.textContent = 'Aggiunta in corso…';
        try {
          const base = root.dataset.shopRoot || '/';
          const response = await fetch(base + 'cart/add.js', {method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)});
          const result = await response.json();
          if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Prodotto non aggiunto. Verifica la disponibilità nella scheda.');
          window.location.assign(root.dataset.cartUrl || base + 'cart');
        } catch (error) {
          status.textContent = error.message || 'Impossibile aggiungere il prodotto. Riprova.';
          button.disabled = false;
        }
      });
    });
  }
  const boot = () => document.querySelectorAll('[data-hss-root]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

/* =====================================================================
   IL PANNELLO DEI SUGGERIMENTI, LARGO QUANTO IL CAMPO.
   Widget Pilot appende il pannello in fondo a <body> e lo posiziona a
   mano, misurando pero' la CASELLA e non il MODULO:
       var rect = input.getBoundingClientRect();
       dropdown.style.width = Math.max(rect.width, 320) + 'px';
   La casella finisce dove comincia il bottone verde della lente, quindi
   il pannello nasce piu' corto del campo di una quarantina di pixel: sta
   allineato a sinistra e si ferma prima a destra, e l'occhio lo legge
   come un pezzo storto. Si vede bene con i prezzi, che sono incolonnati
   a destra e cadono dentro al vuoto.
   Non si corregge alla fonte: widget-pilot.js sta sul CRM e lo carica
   ANCHE il negozio vivo, quindi toccarlo vorrebbe dire toccare il tema
   in uso. Lo rimette a posto la bozza, da fuori: si rimisura il modulo
   e si riscrivono le due proprieta' in linea ogni volta che il widget le
   riscrive.
   Il confronto prima di scrivere non e' un vezzo: senza, la nostra
   scrittura risveglia l'osservatore che l'ha appena attivata e si gira
   in tondo per sempre.
   Su telefono non si fa niente: li' il pannello e' a tutta larghezza
   (position:fixed con left/right a 8px, e con !important, che vince
   comunque sullo stile in linea).
   ===================================================================== */
(() => {
  const PANNELLI = '.hbsr-search-dropdown';
  const MODULO = '.hss-ricerca .searchform';
  const visti = new Set();

  const allinea = (pannello) => {
    const modulo = document.querySelector(MODULO);
    if (!modulo || !pannello.isConnected) return;
    if (getComputedStyle(pannello).position === 'fixed') return;
    const r = modulo.getBoundingClientRect();
    if (!r.width) return;
    const left = Math.round(r.left + window.scrollX) + 'px';
    const width = Math.round(r.width) + 'px';
    if (pannello.style.left === left && pannello.style.width === width) return;
    pannello.style.left = left;
    pannello.style.width = width;
    pannello.style.maxWidth = 'none';
  };

  const sorveglia = (pannello) => {
    if (visti.has(pannello)) return;
    visti.add(pannello);
    new MutationObserver(() => allinea(pannello))
      .observe(pannello, { attributes: true, attributeFilter: ['style'] });
    allinea(pannello);
  };

  const giro = () => {
    document.querySelectorAll(PANNELLI).forEach(sorveglia);
    visti.forEach(allinea);
  };

  new MutationObserver(giro).observe(document.body, { childList: true });
  window.addEventListener('resize', giro);
  giro();
})();
